import { Box, Flex } from "@chakra-ui/react";
import { DownloadDocumentIconButton } from "./DownloadDocumentIconButton/DownloadDocumentIconButton";
import { PreviewDocumentButton } from "./PreviewDocumentButton";
import { getFileExtension, isPdfExtension } from "./utils";

interface Props {
  attachment: { id: string; fileName?: string | null };
}

export const AttachmentRow = ({ attachment }: Props) => {
  const name = attachment.fileName || attachment.id;
  return (
    <Flex align="center" justify="space-between" gap="2" minW="0">
      <Box flex="1" minW="0" fontSize="sm" overflowWrap="break-word">
        {isPdfExtension(getFileExtension(name)) ? (
          <PreviewDocumentButton documentId={attachment.id} documentName={name} />
        ) : (
          name
        )}
      </Box>
      <DownloadDocumentIconButton documentId={attachment.id} size="sm" />
    </Flex>
  );
};
